export default "__VITE_ASSET__96976c90__"